<template>
    <b-card no-body
        border-variant="ep"
        header-bg-variant="ep"
        header-text-variant="white"
        class="timeline-box mb-3">
		<template slot="header">
			<span class="float-left">Evenement {{ this.refCode }}</span>

			<span v-if="availability.loadingAvailability" class="float-right">
				<i class="fa fa-sync" :class="{'fa-spin': availability.loadingAvailability}"></i>
				Beschikbaarheidscheck
			</span>

			<span v-if="!availability.loadingAvailability && !availability.noAvailability && hasOffer" @click="$emit('triggerAvailabilityCheck')" class="float-right">
				<i class="fas fa-check"></i> <span class="underline pointer">Beschikbaarheid</span>
			</span>

			<span v-if="!availability.loadingAvailability && availability.noAvailability" @click="$emit('clickedNoAvailabilityText'); $emit('triggerAvailabilityCheck')" class="float-right">
				 <i class="fas fa-exclamation-triangle text-warning"></i> <span :class="{'underline pointer': availability.hideNoAvailabilityAlert}">Geen beschikbaarheid</span>
			</span>

			<span v-if="!availability.loadingAvailability && !availability.noAvailability && !hasOffer" @click="$emit('clickedNoAvailabilityText')" class="float-right">
				<i class="fas fa-exclamation-circle"></i> <span :class="{'underline pointer': availability.hideNoAvailabilityAlert}">Beschikbaarheid nog onduidelijk</span>
			</span>
		</template>

        <iframe :src="wizardUrl + urlSuffix + dataUrl" class="wizard-frame" frameborder="0" scrolling="no" v-resize="{'heightCalculationMethod': 'taggedElement'}" data-wizard-iframe></iframe>

        <div slot="footer" v-if="showSaveButton">
            <div class="text-right">
                <button class="d-none btn btn-light mr-2" @click="reload()"><em class="fas fa-sync"></em></button>

                <div class="btn-group">
                    <button class="btn btn-ep" v-tooltip="!isValidForEp ? 'Controleer de velden, op dit moment zijn nog niet alle velden juist ingevoerd' : null" :class="{'disabled': !isValidForEp}" @click="save()">
                        Omzetten naar EP-aanvraag <em class="fa fa-arrow-alt-circle-right"></em>
                    </button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
    import Timer from "./timer.vue";

	export default {
        components: {Timer},
        props: {
            refCode: {
                type: String,
                required: true
            },
            hasOffer: {
                type: Boolean,
                required: false
            },
            showSaveButton: {
                type: Boolean,
                required: false,
                default: true
            },
            isValidForEp: {
                type: Boolean,
                required: false,
                default: true
            },
			availability: {
				type: Object,
				required: false,
				default: {}
			}
        },
        data() {
            return {
                wizardUrl: this.hasOffer ? Vue.prototype.apiUrl : Vue.prototype.wizardUrl,
                urlSuffix: this.hasOffer ? 'event/' + this.refCode : 'offerte/#/next-venue/' + this.refCode,
                dataUrl: this.getDataUrl()
            }
        },
        methods: {
            getDataUrl() {
                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams.toString()) {
                    return '?' + urlParams.toString();
                }

                return '';
            },
            save() {
				if (this.isValidForEp) {
					this.$emit('save');
				}
            },
            reload() {
                var iframe = document.querySelector('[data-wizard-iframe]');
                iframe.contentWindow.postMessage({type: 'reload', url: this.wizardUrl + this.urlSuffix + this.dataUrl}, '*');
            }
        }
    }
</script>

<style lang="scss">
    .wizard-frame {
        width: 100%;
        min-height: 600px;
        border: 0;
        margin: 0;
        padding: 1rem;
    }

	.underline {
		text-decoration: underline;
	}
</style>